export default "__VITE_ASSET__Bhsxypcn__"